<template>
  <div>
    <v-card flat v-if="film.id">
      <v-card-text v-if="uploadingLink">
        <v-card-actions class="mb-4">
          <div class="grey--text subheading font-weight-medium">
            <span>{{ $t("Screener.save.magic.link.status.title") }}</span
            >:
            <span>{{ DEFINES.ACCESS_LINK_STATUS_STR[uploadingLink.status] }}</span>
          </div>
          <v-spacer></v-spacer>
          <v-btn
            outline
            color="error"
            @click="
              openAccessLinkDialogWith(
                $t('screener.save.magic.link.title.mark.delete'),
                $t('rms.button.continue'),
                $t('rms.button.cancel'),
                DEFINES.UPLOADING_LINK_WARNINGS.DELETE,
                'deleteMagicLink'
              )
            "
            >{{ $t("screener.save.magic.link.button.delete") }}</v-btn
          >
        </v-card-actions>

        <v-card-text class="text-xs-center pt-0">
          <v-layout row wrap class="grey lighten-4 pa-3">
            <v-flex xs3>
              <div>
                <div class="headline font-weight-light">
                  {{ DEFINES.ACCESS_LINK_STATUS_STR[uploadingLink.status] }}
                </div>
                <div
                  class="subheading grey--text text--darken-3 font-weight-thin"
                >
                  {{ $t("Screener.save.magic.link.status.title") }}
                </div>
              </div>
            </v-flex>
            <v-divider vertical></v-divider>
            <v-flex xs3>
              <div>
                <div class="headline font-weight-light">
                  {{ uploadingLink.no_of_used }}
                </div>
                <div
                  class="subheading grey--text text--darken-3 font-weight-thin"
                >
                  {{ $t("Screener.save.magic.link.redeemed.title") }}
                </div>
              </div>
            </v-flex>
            <v-divider vertical></v-divider> </v-layout
        ></v-card-text>

        <v-layout row wrap v-if="film.id != undefined">
          <v-flex xs12 class="pa-2">
            <v-text-field
              id="registration_link"
              :label="$t('screener.save.magic.link.title')"
              name="registration_link"
              readonly
              color="primary"
              prepend-icon="$vuetify.icons.rms_media_link"
              type="text"
              append-icon="$vuetify.icons.rms_copy"
              @click:append="$copyText(upload_link_url)"
              :value="upload_link_url"
            ></v-text-field>
          </v-flex>
        </v-layout>

        <div v-if="rememberSection">
          <div class="subheading grey--text mb-2">Remember</div>
          <ul v-for="item in DEFINES.UPLOADING_LINK_WARNINGS.GENERATE" :key="item">
            <li>{{ item }}</li>
          </ul>
        </div>
      </v-card-text>
      <v-card-text v-else class="text-xs-center text-md-center">
        <div class="pa-5">
          <v-btn
            color="primary"
            dark
            @click="
              openAccessLinkDialogWith(
                $t('film.save.upload.link.title'),
                $t('film.save.upload.link.generate.dialog.confirm.button'),
                $t('film.save.upload.link.generate.dialog.cancel.button'),
                DEFINES.UPLOADING_LINK_WARNINGS.GENERATE,
                'generateUploadLink'
              )
            "
            >{{ $t("film.save.upload.link.title.mark.generate") }}</v-btn
          >
        </div>
      </v-card-text>
    </v-card>
    <ConfirmationDialogBox
      :title="accessLinkDialog.title"
      :dialog="accessLinkDialog.visible"
      :yesBtnText="accessLinkDialog.yesBtnText"
      :noBtnText="accessLinkDialog.noBtnText"
      @confirm="handleConfirmation(accessLinkDialog.action)"
      @cancel="resetAccessLinkDialog"
    >
      <div v-if="accessLinkDialog.content && accessLinkDialog.content.length">
        <div class="subheading grey--text mb-2">Remember</div>
        <ul v-for="item in accessLinkDialog.content" :key="item">
          <li>{{ item }}</li>
        </ul>
      </div>
    </ConfirmationDialogBox>
  </div>
</template>
<script>
import { mapFields } from "vuex-map-fields";
import DEFINES from "@/defines";
import ConfirmationDialogBox from "@/components/dialogBox/DynamicConfirmationBox";
import i18n from "@/i18n"
export default {
  name: "UploadingLink",
  props: {
    film: {
      type: Object,
      default: null
    },
    company: {
      type: Object
    },
    rememberSection: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      accessLinkDialog: {
        visible: false,
        title: null,
        yesBtnText: null,
        noBtnText: null,
        content: null,
        action: null
      },
      upload_link_url: null
    };
  },
  components: {
    ConfirmationDialogBox
  },

  mounted() {
    this.getUploadLink();
  },

  computed: {
    ...mapFields("screenerAccessLink", {
      uploadingLink: "upload_link"
    })
  },


  methods: {
    async generateUploadLink() {
      await this.$store
        .dispatch("screenerAccessLink/generateUploadLink", {
          film_id: this.film.id
        })
        .then(response => {
          this.$store.dispatch("app/showMessage", {
            message: i18n.t("film.save.upload.link.generated.successfully"),
            color: "success"
          });
          if (response.upload_link) {
            var uuid = response.upload_link.id;
            this.upload_link_url = `${DEFINES.VUE_APP_URL}company/${this.$route.params.company_id}/film/${this.$route.params.film_id}/link/${uuid}`;
          }
        })
        .catch(error => {
          this.$store.dispatch("app/showMessage", {
            message: error.message,
            color: "error"
          });
        })
        .finally(() => {
          this.resetAccessLinkDialog();
        });
    },

    async deleteMagicLink() {
      await this.$store
        .dispatch("screenerAccessLink/deleteUploadLink", {
          film_id: this.film.id
        })
        .then(response => {
          this.$store.dispatch("app/showMessage", {
            message: i18n.t(
              "film.save.upload.link.marked.delete.success.message"
            ),
            color: "success"
          });
        })
        .catch(error => {
          this.$store.dispatch("app/showMessage", {
            message: error.message,
            color: "error"
          });
        })
        .finally(() => {
          this.resetAccessLinkDialog();
        });
    },

    async getUploadLink() {
      await this.$store
        .dispatch("screenerAccessLink/getUploadLink", {
          film_id: this.$route.params.film_id
        })
        .then(response => {
          if (response.upload_link) {
            var uuid = response.upload_link.id;
            this.upload_link_url = `${DEFINES.VUE_APP_URL}company/${this.$route.params.company_id}/film/${this.$route.params.film_id}/link/${uuid}`;
          }
        })
        .catch(error => {
          console.error(error);
        })
        .finally(() => {
          this.resetAccessLinkDialog();
        });
    },

    openAccessLinkDialogWith(title, yesBtnText, noBtnText, content, action) {
      // console.log("action --> ", action);
      this.accessLinkDialog.visible = true;
      this.accessLinkDialog.title = title;
      this.accessLinkDialog.yesBtnText = yesBtnText;
      this.accessLinkDialog.noBtnText = noBtnText;
      this.accessLinkDialog.content = content;
      this.accessLinkDialog.action = action;
    },

    resetAccessLinkDialog() {
      this.accessLinkDialog.visible = false;
      this.accessLinkDialog.title = null;
      this.accessLinkDialog.yesBtnText = null;
      this.accessLinkDialog.noBtnText = null;
      this.accessLinkDialog.content = null;
      this.accessLinkDialog.action = null;
    },

    handleConfirmation(handlerName) {
      this[handlerName]();
    }
  }
};
</script>
